import PublicNetworkClient from "helpers/publicNetwork";

const appLogin = async (formData) => {
  const { data } = await PublicNetworkClient.post(`/login`, formData);
  return data;
};

const getOtp = async (formData) => {
  const { data } = await PublicNetworkClient.post(`/public/forgotPassword`, formData);
  return data;
};

const verifyOtp = async (formData) => {
  const { data } = await PublicNetworkClient.put(`/public/verifyOtp`, formData);
  return data;
};

const setPassword = async (formData) => {
  const { data } = await PublicNetworkClient.put(`/public/resetPassword`, formData);
  return data;
};

const contact = async (formData) => {
  const { data } = await PublicNetworkClient.post(`/public/contactUs`, formData);
  return data;
};

export {
  appLogin,
  contact,
  getOtp,
  verifyOtp,
  setPassword
};
